// extracted by mini-css-extract-plugin
module.exports = {"copyButton":"CopyToClipboardButton_copyButton_3stYK"};